import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux'

import { AddressShape, AddressActionCreatorsShape as AddressActionCreators } from './propTypes'

import AddressDisplay from './AddressDisplay';
import { RadioInput } from '../../components';
import ActiveAddressInAddressSelectorListContainer from './ActiveAddressInAddressSelectorListContainer'
import { translateResourceString } from '../../../util/translationUtility';

import {
    hiddenAnchorStyle,
    pretendAnchorStyle
} from '../../components'

class AddressSelectorList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeAddressId: ''
        };

        this.onDeleted = this.onDeleted.bind(this);
        this.onSelected = this.onSelected.bind(this);
        this.onItemClick = this.onItemClick.bind(this);
        this.onRadioSelected = this.onRadioSelected.bind(this);
    }

    beginEdit(Id) {
        if (this.state.activeAddressId !== '') {
            // Only set active if we had an active before
            this.setState({ activeAddressId: Id });
        }
        this.props.onBeginEdit(Id);
    }

    onRadioSelected(id) {
        this.setState({ activeAddressId: id });
        this.props.onAddressSelected(id);
    }

    onSelected(id) {
        this.props.onAddressSelected(id);
        this.props.onDoneSelecting(id);
        this.setState({ activeAddressId: '' });
    }

    onDeleted(id) {
        this.setState({ activeAddressId: '' });
    }

    onItemClick(id) {
        this.setState({ activeAddressId: id });
    }

    render() {
        const listComponent = this;
        const props = this.props;
        const listItems = this.props.addresses.map((address) => {
            const isSelected = props.selectedAddressId === address.Id;
            const focused = listComponent.state.activeAddressId === address.Id;
            return (
                <div
                    className='p-2 bg-grey-light'
                    key={address.Id}
                    style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginTop: 7, marginBottom: 7 }}
                >
                    <div
                        className={`address ${isSelected ? 'selected' : ''}`}
                        style={{ display: 'flex' }}
                    >
                        <RadioInput
                            selected={isSelected}
                            onClick={() => listComponent.onRadioSelected(address.Id, listComponent.props.useForAnotherSelected)}
                        />
                        {this.props.allowAdding &&
                            <button
                                className="btn btn-link"
                                style={hiddenAnchorStyle}
                                onClick={(e) => { e.preventDefault(); listComponent.onItemClick(address.Id); }}
                                >
                            <AddressDisplay address={address} compact />
                            </button>
                        } 

                        {!!!this.props.allowAdding &&
                            <AddressDisplay address={address} compact />
                        } 
                    </div>

                    {this.props.allowAdding &&<div className="btn-group" role="group">
                            <button
                                className="btn btn-icon"
                                style={{}}
                                onClick={(e) => {
                                    e.preventDefault();
                                    listComponent.beginEdit(address.Id);
                                }}>
                                <span
                                    style={pretendAnchorStyle}
                                    className='far fa-edit'
                                />
                                &nbsp;
                                <span className="sr-only">{translateResourceString("/Checkout/Address/EditButton")}</span>
                            </button>
                        </div>
                    } 
                </div>
            );
        });

        return (
            <div>
                {listItems}
                {props.allowAdding && <button
                    href='#'
                    className='btn btn-primary'
                    style={{ marginTop: 15 }}
                    onClick={() => this.beginEdit()}>{translateResourceString("/Checkout/Address/AddNewButton")}</button>}
            </div>
        )
    }
}

AddressSelectorList.propTypes = {
    addressActionCreators: PropTypes.shape(AddressActionCreators).isRequired,
    addresses: PropTypes.arrayOf(AddressShape.propTypes).isRequired,
    allowAdding: PropTypes.bool.isRequired,
    onAddressSelected: PropTypes.func.isRequired,
    onDoneSelecting: PropTypes.func.isRequired,
    selectAddressMessage: PropTypes.string.isRequired,
    selectedAddressId: PropTypes.string
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    onAddressSelected: (id, address) => dispatch(ownProps.addressActionCreators.select(id, address))
})

const AddressSelectorListContainer = connect(
    null,
    mapDispatchToProps
)(AddressSelectorList)

export default AddressSelectorListContainer;